import { useContext } from 'react';
import { AdminAuthContext } from '../auth/AdminAuthContext';

/**
 * useAdminAuth
 * Returns { isAuthed, secret, login, logout }.
 * Must be used within <AdminAuthProvider>.
 */
export default function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error('useAdminAuth must be used inside an AdminAuthProvider');
  }
  return ctx;
}
